import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westHartfordConfig } from "./data";

export default function WestHartfordPage() {
  return <CityPageTemplate config={westHartfordConfig} />;
}